import { resolveProp } from '@clearscore/helpers.resolve-props';

export default (payload) => {
    const verticalId = resolveProp('metadata.vertical.id', payload);
    if (!verticalId) return {};

    const { results, ...rest } = payload;
    const productTypes = results.map((result) => result.id);

    return {
        [verticalId]: {
            ...rest,
            productTypes,
        },
    };
};
